@if(config.dialogMode){
    @if(config.description){
        <div [innerHtml]="description" ></div>
    }
}
@else{
    <div class="mat-headline-1">{{config.title}}</div>
}
<div fxLayout="row" class="content-container">
    <div fxFlex="250px" fxLayout="column" fxLayoutAlign="start start"
        class="group-container"
        *ngIf="!config.collapseGroupNav">
        <div class="group"
            *ngFor="let group of config.groups"
            (click)="selectGroup(group)"
            [ngClass]="{'selected-group': group === selectedGroup, 'unselected-group': group !== selectedGroup}">
            <div class="group-text">{{group.header}}</div>
        </div>
    </div>

    @if(config.dialogMode){
        <div fxFlex class="selected-group-container"
                [formGroup]="config.form">
            <app-loading [loaded]="selectedGroup.sections.length > 0"></app-loading>
            
            @if(selectedGroup.sections.length > 0){
                <div class="section-container"
                        [ngClass]="{'section-container-last': l}"
                        *ngFor="let section of selectedGroup.sections; let l = last">    
                    <app-group-edit-section [section]="section"
                            [selectedSection]="selectedSection"
                            [dialogMode]="config.dialogMode"
                            [form]="section.form ? section.form : config.form"
                            (sectionEditing)="editSection($event)"></app-group-edit-section>
                    <mat-divider></mat-divider>
                </div>
            }

            <div style="height: 25px">&nbsp;</div>
        </div>
    }
    @else{
        <div fxFlex class="selected-group-container">
            <app-loading [loaded]="selectedGroup.sections.length > 0"></app-loading>            
            <ng-container *ngIf="selectedGroup.sections.length > 0">
                <div class="section-container"
                        *ngFor="let section of selectedGroup.sections"    
                        [formGroup]="section.form">    
                    <app-group-edit-section [section]="section"
                            [selectedSection]="selectedSection"
                            [dialogMode]="config.dialogMode"
                            [form]="section.form"
                            (sectionEditing)="editSection($event)"></app-group-edit-section>
                    <mat-divider></mat-divider>
                </div>
            </ng-container>
        </div>
    }
</div>